<template>
  <div>
    <v-progress-linear v-if="loading" indeterminate></v-progress-linear>

    <v-container>
      <SearchBar class="mt-2 mx-4" v-model="search" :hideBackBtn="true" />
      <div>{{ count }} Employees</div>
      <v-row class="pb-3 mr-3" align-content="center" justify="space-between">
        <v-col>
          <v-progress-linear v-if="subscription" dark color="primary" background-color="blue-grey lighten-4"
            :value="percentage" rounded height="25">
            <strong>{{ totalAttendees }} of {{ employeeCountAllow }} Attendees
            </strong>
          </v-progress-linear>
          <v-skeleton-loader class="ma-0" v-else type="heading"></v-skeleton-loader>
        </v-col>
        <v-col cols="2" class="text-right" v-if="employeeAccess.employee && employeeAccess.employee.create">
          <v-btn rounded small dark @click="createEmployee" color="primary">New</v-btn>
        </v-col>
      </v-row>
      <v-list two-line class="touch-view-container">
        <template v-for="(item, index) in employees">
          <v-list-item :key="index">
            <v-list-item-avatar>
              <v-avatar color="primary" size="56">
                <v-img v-if="item.imageURL" :src="item.imageURL"></v-img>
                <v-img v-else src="@/assets/images/user.jpeg"></v-img>
              </v-avatar>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title v-text="item.name" class="text-capitalize"></v-list-item-title>

              <v-list-item-subtitle>
                <span v-if="item.Department" class="mr-2"><v-chip small>{{ item.Department.name }}</v-chip></span>
                <span v-if="
                  (item.metadata &&
                    item.metadata.timeClockLogin &&
                    item.metadata.timeClockLogin.admin) || (item.metadata &&
                      item.metadata.timeClockLogin &&
                      item.metadata.timeClockLogin.employee)
                ">
                  <v-icon small color="yellow darken-4" v-if="item.owner">mdi-crown</v-icon>
                  <span v-if="item.metadata &&
                    item.metadata.timeClockLogin &&
                    item.metadata.timeClockLogin.admin">Admin</span>
                  <span class="pl-1" v-if="item.metadata &&
                    item.metadata.timeClockLogin &&
                    item.metadata.timeClockLogin.employee">Attendee</span>
                  <span class="pl-1" v-if="item.metadata &&
                    item.metadata.timeClockLogin &&
                    item.metadata.timeClockLogin.portal">Portal</span>

                </span>


              </v-list-item-subtitle>
              <!-- <v-list-item-subtitle>test</v-list-item-subtitle> -->
              <!-- <v-list-item-subtitle
                v-if="
                  item.metadata &&
                  item.metadata.timeClockLogin &&
                  item.metadata.timeClockLogin.employee
                "
                >Attendee</v-list-item-subtitle
              > -->
            </v-list-item-content>
            <v-list-item-action>
              <v-menu offset-y bottom left v-if="!isReadOnly(item)">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item @click.stop.prevent="editEmployee(item)"
                    v-if="employeeAccess.employee && employeeAccess.employee.edit">
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click.stop.prevent="deleteEmployee(item)"
                    v-if="employeeAccess.employee && employeeAccess.employee.delete">
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-action>
          </v-list-item>

          <v-divider inset v-if="index < employees.length - 1" :key="index + 100"></v-divider>
        </template>
      </v-list>
    </v-container>
  </div>
</template>

<script>
import employeeService from "../service";
import "vue-swipe-actions/dist/vue-swipe-actions.css";
// eslint-disable-next-line no-unused-vars
// import css from "../../src/styles/vue-swipe-actions.css";
import locationService from "@/modules/Location/service.js";
import { mapGetters } from 'vuex';

export default {
  name: "employee-list",
  data() {
    return {
      subscription: null,
      employeeCountAllow: 0,
      totalAttendees: 0,
      search: null,
      deleteEmployees: false,
      employees: [],
      count: 0,
      limit: 50,
      offset: 0,
      loading: false,
      rowsPerPageItems: [10, 25, 50, 100],
      pagination: {
        rowsPerPage: 10,
        sortBy: "name",
      },
      enabled: true,
      page: 0,
      revealed: {},
      lastEventDescription: "",
    };
  },
  async created() {
    this.loadSubscription();
    this.getAll();
  },
  computed: {
    ...mapGetters("employee", ['employee', 'employeeAccess']),
    percentage() {
      return (100 * this.totalAttendees) / this.employeeCountAllow;
    },
  },
  // mounted() {
  //   // ideally should be in some global handler/store
  //   window.addEventListener("keydown", this.onKeyDown);
  //   window.addEventListener("keyup", this.onKeyUp);
  // },
  // beforeDestroy() {
  //   window.removeEventListener("keydown", this.onKeyDown);
  //   window.removeEventListener("keyup", this.onKeyUp);
  // },
  watch: {
    search() {
      if (this.search.length > 3 || this.search.length === 0) {
        this.getAll();
      }
    },
  },
  sockets: {
    employeeStatusChange() {
      this.getAll();
    },
  },
  methods: {
    isReadOnly(selectedEmployee) {
      if (selectedEmployee.owner && (this.employee.id != selectedEmployee.id)) return true
      else return false
    },
    createEmployee() {
      this.$router.push({ name: "employee-create" });
    },
    loadSubscription() {
      const location = JSON.parse(
        localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}location`)
      );
      // // console.log("location", location);
      if (location) {
        return locationService.getSubscription(location.id)
          .then(async (response) => {
            // console.log("sub", response.data);
            this.subscription = response.data[0]
            if (this.subscription) {
              let total = 0;
              this.subscription.items.data.map((row) => {
                if (row.price.metadata && row.price.metadata.employeeCount) {
                  // console.log("row", row.price.metadata);
                  total += parseInt(row.price.metadata.employeeCount) * row.quantity;
                }
              });
              // // console.log("total ", total);
              if (total !== 0) {
                this.employeeCountAllow = total;
              }
              if (this.subscription.metadata && this.subscription.metadata.allowEmployee) {
                this.employeeCountAllow = this.subscription.metadata.allowEmployee;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    remove(item) {
      this.$set(
        this.mockSwipeList,
        this.page,
        this.mockSwipeList[this.page].filter((i) => i !== item)
      );
    },
    setLastEvent(name, { item, index }) {
      this.lastEventDescription = {
        name,
        index,
        id: item.id,
      };
    },
    getAll() {
      let noCache = true;
      this.loading = true;
      return employeeService
        .getAll(
          {
            limit: this.limit,
            offset: this.offset,
            local: true,
            noPagination: true,
            search: this.search,
            orderBy: [this.pagination.sortBy],
          },
          noCache
        )
        .then(async (response) => {
          this.totalAttendees = 0
          console.log('response', response)
          const employees = response.data;
          if (this.employeeAccess.onlyView) {
            // console.log('test test')

            await Promise.all(employees.map(e => {
              if (
                e.metadata &&
                e.metadata.timeClockLogin &&
                e.metadata.timeClockLogin.employee
              ) {
                this.totalAttendees++;
              }
              this.employeeAccess.onlyViewEmployee.map(emp => {
                if (emp === e.id) {
                  this.employees.push(e);
                }
              })
            }))
          } else {
            await Promise.all(employees.map(e => {
              if (
                e.metadata &&
                e.metadata.timeClockLogin &&
                e.metadata.timeClockLogin.employee
              ) {
                this.totalAttendees++;
              }
              // this.employeeAccess.onlyViewEmployee.map(emp => {
              //     if (emp === e.id) {
              //       this.employees.push(e);
              //     }
              //   })
            }))
            this.employees = employees.sort((a, b) => {
              if (a.name < b.name) {
                return -1;
              }
              if (a.name > b.name) {
                return 1;
              }
              return 0;
            });

          }

          // this.employees = response.data;

          // console.log('response.data is :', this.employees)
          this.count = response.count;
          // if (this.employees) {
          //   this.employees.map((e) => {
          //     if (
          //       e.metadata &&
          //       e.metadata.timeClockLogin &&
          //       e.metadata.timeClockLogin.employee
          //     ) {
          //       this.totalAttendees++;
          //     }
          //     // this.totalAttendees
          //   });
          // }
          this.loading = false;
          return response;
        })
        .catch((error) => {
          this.loading = false;
          throw error;
        });
    },
    deleteEmployee(employee) {
      return this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then((result) => {
          if (result.isConfirmed) {
            employeeService.delete(employee.id).then((response) => {
              if (response.data) {
                this.$toast.success("Employee has been deleted", {
                  timeout: 2000,
                });

                this.getAll();
              }
            });
          }
        })
        .catch((error) => {
          this.$toast.error(error.data ? error.data.message : "Error", {
            timeout: 2000,
          });
        });
    },
    editEmployee(employee) {
      if (employee) {
        return this.$router.push({ name: "employee-edit", params: { id: employee.id, fromList: true } });
      }
      return alert("Id Not Found");
    },
  },
};
</script>

<style scoped>
.touch-view-container {
  height: calc(100vh - 260px);
  width: 100%;
  overflow: auto;
}
</style>
